export const carrierLogoURL = (carrierId: string): string => {
  return `https://docs.insurancemenu.com/0/${carrierId.replace(/\s+/g, '')}.png`;
};
